"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogLevel = void 0;
var logger_1 = require("../../../logger");
/**
 * Returns the LogLevel for the given debugValue or undefined if it is invalid,
 * i.e., if the debugValue is not a boolean or LogLevel string.
 *
 * @param debugValue debug value at config
 * @returns LogLevel of the given debugValue or undefined if the provided value is invalid
 */
function getLogLevel(debugValue) {
    if (typeof debugValue === 'boolean') {
        if (debugValue) {
            return logger_1.LogLevels.DEBUG;
        }
        else {
            return logger_1.LogLevels.NONE;
        }
    }
    else if (typeof debugValue === 'string' && (0, logger_1.isLogLevelString)(debugValue)) {
        return debugValue;
    }
    else {
        return undefined;
    }
}
exports.getLogLevel = getLogLevel;
